module.exports = __webpack_public_path__ + "img/zhhb-1.1375267e.png";